import { PixelRatio } from 'react-native';

const scaleDimension = (size: number) => size;
const scale = (size: number) => Math.round(PixelRatio.roundToNearestPixel(scaleDimension(size)));
const verticalScale = (size: number) => scale(size);

export { scale, verticalScale };
